module.exports = __webpack_public_path__ + "static/assets/208e51b7ec440e9cad5d2bf72f584d04.png";